export default __webpack_public_path__ + "st-images/newbuilds-in-page-how-we-calculate.jpg";